export default __webpack_public_path__ + "static/media/3.addc65a2.png";